import { supabase } from '@/lib/supabase';

/**
 * Aktif döviz kurlarını getir
 * @returns {Promise<Object>} CurrencyContext'in beklediği formatta kurlar
 */
export async function getCurrencyRates() {
  try {
    const { data, error } = await supabase
      .from('currency_rates')
      .select('*')
      .eq('is_active', true);
    
    if (error) throw error;
    
    // CurrencyContext'in beklediği formata dönüştür
    // { GBP: { symbol: '£', code: 'GBP', rate: 1 }, ... }
    const rates = {};
    
    if (data && data.length > 0) {
      data.forEach(currency => {
        rates[currency.currency_code] = {
          symbol: currency.currency_symbol,
          code: currency.currency_code,
          rate: parseFloat(currency.rate_to_gbp)
        };
      });
    }
    
    return rates;
  } catch (error) {
    console.error('Error fetching currency rates:', error);
    throw error;
  }
}
